export default {
  en: {
    banner_title: 'How to watch BBC iPlayer with PlexVPN outside the UK?',
    banner_des: 'The BBC iPlayer produces the best drama and documentary shows in the world, but only available in the UK. If you are not in the UK, you can still access BBC iPlayer with PlexVPN. Just download PlexVPN, and connect to the server tagged iPlayer in the UK, you can watch your favorite videos quickly and smoothly.',
    banner_btn: 'Get PlexVPN Now',
    bbcInfo_title: 'The wonderful TV shows and movies on BBC iPlayer',
    bbcInfo_des: 'The BBC iPlayer and its related channels provide a variety of content, such as straight news, drama, comedy, soap opera, and children\'s programs. BBC iPlayer regularly updates the episodes that have just been broadcast on TV. In addition, it also deletes episodes from two months ago. International viewers cannot access all BBC TV channels because they only can be watched through British cable providers.',
    benefit_title: 'Advantages of using PlexVPN to watch BBC iPlayer',
    benefit_item1: 'Unlock the GEO restrictions, watch the BBC iPlayer outside the UK',
    benefit_item2: 'High-speed & stable servers enable you to watch HD/4K videos smoothly ',
    benefit_item3: 'No traffic limit, the best choice for you to watch BBC iPlayer',
    getPlex: 'Get PlexVPN Now',
    downloadPlex: 'Download PlexVPN',
    steps_title: '3 simple steps to get PlexVPN and watch the BBC iPlayer outside the UK',
    steps_item1: 'Create a PlexVPN account, then download PlexVPN and sign in your account',
    steps_item2: 'Select the server tagged with iPlayer and connect to it',
    steps_item3: 'Sign in your BBC iPlayer account and watch the 4K videos',
    review_title: 'Reviews',
    feature_title: 'Why should I select PlexVPN?',
    features_title1: 'Bypass GEO restrictions',
    features_title2: 'Gigabit acceleration, unlimited bandwidth',
    features_title3: 'High-quality servers all around the world',
    features_title4: 'Data encryption, no logs',
    features_title5: 'Support for multi-platform devices',
    features_title6: 'Friendly customer & technical support',
    features_con1: 'Due to the content licensing restrictions, BBC iPlayer can only be played in the UK. PlexVPN can help you break through GEO restrictions and easily access the videos, music, social media, etc in any country/region.',
    features_con2: 'PlexVPN provides high-quality servers to unlock mainstream video websites, such as Netflix, Hulu, BBC iPlayer, etc. With our high-speed and stable servers, you can watch ultra HD videos smoothly, without any delay or buffering. And there is no bandwidth and traffic limit.',
    features_con3: 'PlexVPN provides servers all around the world. There are multiple servers in each country and region, if an IP is blocked by BBC iPlayer, you can connect to another server and continue to watch your favorite programs.',
    features_con4: 'With the latest & strongest ECC encryption technology, PlexVPN can hide your IP address and encrypt your network data. No one knows what you are doing. The strict no-logs policy will not log your data.',
    features_con5: 'PlexVPN has user-friendly clients for Android, iOS, macOS, Ubuntu, and Android TV devices. Users can enjoy the cross-platform use of mobile phones, tablets, and computers.',
    features_con6: 'If you encountered any problems while using PlexVPN, or you have any suggestions or advice for us, you can contact our customer support team via online feedback in the APP.',
    faqs_title: 'FAQs to watch BBC iPlayer',
    faqs_title1: 'Why do I need PlexVPN to watch BBC iPlayer?',
    faqs_con1: 'BBC iPlayer gets your location with your IP address. If BBC iPlayer detects that your IP address is not in the UK, it will deny your access and display the following error message:',
    faqs_des1: '\“BBC iPlayer only works in the UK, it\'s due to rights issues. In the UK? Here\'s some advice.\”',
    faqs_des2: 'However, you can easily change your location with PlexVPN. You can install PlexVPN on your devices, then connect to the servers tagged with iPlayer in the UK to watch the wonderful shows on BBC iPlayer.',
    faqs_title2: 'How to use PlexVPN to access BBC iPlayer?',
    faqs_con2: 'It is very simple! You just need to connect to the servers tagged with iPlayer in the UK, PlexVPN will provide you the UK IP address.',
    faqs_title3: 'Which device can I use to watch BBC iPlayer? ',
    faqs_con3: 'You can use PlexVPN on almost any device. PlexVPN has user-friendly clients for Android, iOS, macOS, Ubuntu, and Android TV devices.',
    faqs_title4: 'What else can I do with PlexVPN?',
    faqs_con4: 'With PlexVPN, you also can bypass censorship in certain countries and browse the web safely, including Netflix, Hulu, Amazon Prime Video, Disney+ and HBO Go, etc.',
    footer_con1: 'User praise/trust rating',
    reviews_user1: 'Jesse Elizondo',
    reviews_data1: '2020.05.24',
    reviews_con1: '\"The Plex VPN works consistently well and is one of my favs.\"',
    reviews_user2: 'Camara Abou Mohamed',
    reviews_data2: '2019.03.21',
    reviews_con2: "\"I love plexVPN because of its best design colour .And it's develop others app including the profile e.t.c\"",
    reviews_user3: 'Ehsan Muhammad',
    reviews_data3: '2020.05.05',
    reviews_con3: "\"Dear vpn Developer, you are the best among all vpn Developers.. World's best vpn Plexvpn. G Hats off to you all the team..\"",
    reviews_user4: 'Kenneth Mugwanya',
    reviews_data4: '2019.05.14',
    reviews_con4: '\"Supper fast connection Speed VPN I liked it in the first installation. 5/5 stars. Highly recommended. Thanks developer Team.\"',
    reviews_user5: 'Nouman Nomi',
    reviews_data5: '2020.08.12',
    reviews_con5: '\"Its good vpn. I like this.very easy to connect and quickly response\"',
  },
  zh: {
    banner_title: '如何使用 PlexVPN 在英国境外观看 BBC iPlayer',
    banner_des: '英国广播公司 iPlayer 制作了世界上最好的戏剧和纪录片节目，但仅在英国提供。如果您未居住在英国，仍然可以通过 PlexVPN 可访问 BBC iPlayer。您只需要下载 PlexVPN，连接标注 iPlayer 的英国服务器，即可快速流畅地观看喜欢的视频。',
    banner_btn: '立即获取 PlexVPN',
    bbcInfo_title: 'BBC iPlayer 上的精彩电视节目和电影',
    bbcInfo_des: '英国广播公司 iPlayer 及其相关频道提供各种内容，从硬新闻到戏剧，从喜剧到肥皂剧到儿童节目。 BBC iPlayer 会定期更新刚刚在电视上播出的剧集。此外，它还会删除两个月前的剧集。国际观众无法收看所有的 BBC 电视频道，因为他们只能通过英国有线电视提供商收看。',
    benefit_title: '使用 PlexVPN 观看 BBC iPlayer 的好处',
    benefit_item1: '突破封锁，在英国境外观看 BBC iPlayer',
    benefit_item2: '高速稳定，HD / 4K 视频流畅观看',
    benefit_item3: '无限流量，观看 BBC iPlayer 的最佳选择',
    getPlex: '立即获取 PlexVPN',
    downloadPlex: '下载 PlexVPN',
    steps_title: '3个简单步骤获得 PlexVPN 并观看英国 BBC iPlayer',
    steps_item1: '注册 PlexVPN 并下载客户端登陆账号',
    steps_item2: '选择标注 iPlayer 的英国线路进行连接',
    steps_item3: '访问 BBC iPlayer，观看4K 高清视频',
    review_title: '用户评论',
    feature_title: '为什么选择 PlexVPN',
    features_title1: '绕过地理位置封锁',
    features_title2: '千兆加速，无限流量',
    features_title3: '优质服务器遍布全球',
    features_title4: '数据加密，无日志',
    features_title5: '设备兼容，易于使用',
    features_title6: '友好的客服 & 技术支持',
    features_con1: '由于内容许可限制，BBC iPlayer 只能在英国播放。PlexVPN 可以帮您突破地域限制，轻松访问任何国家/地区的视频、音乐、社交媒体等。',
    features_con2: 'PlexVPN 提供 BBC iPlayer、Netflix、Hulu 等主流视频网站专线，高速稳定，因此即使是超高清视频也可以流畅播放，不会出现延迟或缓冲，而且没有宽带和流量限制。',
    features_con3: 'PlexVPN 拥有全球服务器，由于其在每个国家都拥有多台服务器，因此如果一个 IP 被 BBC iPlayer 封锁，您还可以连接到另一台服务器，继续观看自己喜欢的节目。',
    features_con4: 'PlexVPN 通过最新、最强的椭圆曲线加密技术，隐藏您的 IP 地址并加密您的网络数据，因此没人能看到您在做什么。严格的无日志政策不会记录您的数据。',
    features_con5: 'PlexVPN 拥有 Android、iOS、Window、MacOS，Ubuntu 及 Android TV 等客户端，界面友好，简单易用。还可手机，平板，电脑跨平台使用！',
    features_con6: '使用过程中遇到任何问题，或者您对 PlexVPN 有任何的意见或者建议，都可以通过客户端在线反馈联系我们。',
    faqs_title: '观看 BBC iPlayer 常见问题',
    faqs_title1: '为什么需要 PlexVPN 才能观看 BBC iPlayer？',
    faqs_con1: 'BBC iPlayer 使用您的 IP 地址来查知您的位置。如果 BBC iPlayer 检测到您使用的是非英国 IP，它将拒绝您访问并显示以下错误消息：',
    faqs_des1: '\“错误消息：BBC iPlayer 仅在英国工作。抱歉，是由于版权问题。在英国？这里有一些建议。\”',
    faqs_des2: '然而，您可以使用 PlexVPN 轻松更改您的 IP。您可以直接在设备上安装 PlexVPN 客户端，连接标注 iPlayer 英国服务器，即可观看 BBC iPlayer 上的精彩节目。',
    faqs_title2: '如何使用 PlexVPN 访问 BBC iPlayer？',
    faqs_con2: '这很简单！您只需连接到标注 iPlayer 英国服务器即可。PlexVPN 会自动为您提供英国的 IP 地址。',
    faqs_title3: '我可以在哪些设备上观看 BBC iPlayer？',
    faqs_con3: '您几乎可以在任何设备上使用 PlexVPN 并观看 BBC iPlayer。不管操作系统是 Android、iOS、Window、MacOS，Ubuntu 还是 Android TV，PlexVPN 都拥有操作简便的客户端。',
    faqs_title4: '使用 PlexVPN 还能做什么？',
    faqs_con4: '借助 PlexVPN，您可以绕过某些国家/地区的审查制度，并安全地浏览网络，包括 Netflix，Hulu，Amazon Prime Video，Disney +和 HBO Go 之类的服务。',
    footer_con1: '用户好评度/信任等级',
    reviews_user1: 'AE chihiro',
    reviews_data1: '2020年6月17日',
    reviews_con1: '\“买了会员了，体验很好。在 PC 上 看油管 4K 没问题，手机上我用被限速的 4G 照样流畅观看 720P。\”',
    reviews_user2: 'Uriah Cong',
    reviews_data2: '2020年05月24日',
    reviews_con2: '\“一直都好用！你们是支撑我在国内上网冲浪的精神支柱，请一定好好地做下去！24小时 VPN 没在怕的！\”',
    reviews_user3: 'Ava Lanche',
    reviews_data3: '2019年3月31日',
    reviews_con3: '\“速度比较稳定，价格也适中，客服也耐心，用了得两年了吧，希望能坚持下去！\”',
    reviews_user4: 'xingyu peng',
    reviews_data4: '2020年5月5日',
    reviews_con4: '\“速度真的很快，而且有活动，综合下来也不贵，关键是手机电脑都可以用，真的很好。\”',
    reviews_user5: 'yo moe',
    reviews_data5: '2019年5月14日',
    reviews_con5: '\“一直在用这个！感觉套餐价格比较能接受，而且连接很稳定，客服也是真的非常亲切耐心~加油＾０＾~\”',
    reviews_user6: 'NT.Tp.',
    reviews_data6: '2020年8月12日',
    reviews_con6: '\“一个美国的朋友推荐给我的，开了2个季度的会员。使用了大半年，挺好用，连接稳定没有广告。\”',
    
  }
}


// WEBPACK FOOTER //
// ./src/views/promotion/Bbc/lang.js